import React from 'react'
import Footer from '../Components/Footer/Footer'
import LoginForm from '../Components/LoginForm/LoginForm'


function Login() {
  return (
    <div className='login'>
      <LoginForm/>
      <Footer/>
    </div>
  )
}

export default Login
